<div id="todo" class="page-layout carded left-sidebar inner-scroll">
    <fuse-sidebar class="sidebar" name="supplier-order-main-sidebar" position="left" lockedOpen="gt-md">
        <storehouse-use-main-sidebar></storehouse-use-main-sidebar>
    </fuse-sidebar>
    <!-- CONTENT -->
    <div class="center mat-card" *ngIf="storehouseUse != null">
        <selling-navbar></selling-navbar>

        <div class="content-card" style="overflow-y: scroll;">
            <div class="h2 mt-16">{{ 'Use details'|translate }}: {{storehouseUse.items.length}} {{'products'|translate}}</div>
            <br/>
            <table class="table">
                <thead>
                <tr>
                    <td>{{'No.'|translate}}</td>
                    <td>{{'Name'|translate}}</td>
                    <td>{{'Quantity'|translate}}</td>
                    <td>{{'Unit'|translate}}</td>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let item of storehouseUse.items; index as i">
                    <td>{{i+1}}</td>
                    <td>{{item.product.name}}</td>
                    <td>{{item.quantity}}</td>
                    <td>{{item.unit.name}}</td>
                </tr>
                </tbody>
            </table>
            <br/>
            <br/>
            <table class="table">
                <tr>
                    <td>{{'Customer'|translate}}</td>
                    <td>{{storehouseUse.customer.firstName}} {{storehouseUse.customer.lastName}}</td>
                </tr>
                <tr>
                    <td>{{'Worker'|translate}}</td>
                    <td>{{storehouseUse.worker.firstName}} {{storehouseUse.worker.lastName}}</td>
                </tr>
            </table>
        </div>
    </div>
</div>
